export default ($node: HTMLElement) => {
	let isFormInputDetected = false;
	let formInputStartTime: number | null = null;
	const form = $node.closest('form') as HTMLFormElement | null;
	const timestampInputField = $node.querySelector('input[name*="timestamp"]') as HTMLInputElement | null;

	const updateTimestamp = () => {
		if (!isFormInputDetected) {
			isFormInputDetected = true;
			formInputStartTime = Date.now();
		}
	};

	$node.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea').forEach((input) => {
		input.addEventListener('input', updateTimestamp);
	});

	if (form && timestampInputField) {
		form.addEventListener('submit', (e: SubmitEvent) => {
			if (formInputStartTime !== null) {
				timestampInputField.value = (Date.now() - formInputStartTime).toString();
			}
		});
	}
};
